import dayjs, { Dayjs } from 'dayjs';

export const formatDateToDateTimeIsoString = (date: string | null | Date | undefined | Dayjs) => {
  return dayjs(date).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
};
